export const hiddenDrawerRoutes = [
    "/",
    "/messages",
    "/not-found",
    "/privacy-policy",
    "/creator-agreement",
    "/terms-of-use",
    "/initial-setting",
    "/messages",
    "/messages/:conversationId/:conversationSubject",
    "/welcome",
    "/logout",
    "/select-enterprise",
    "/success",
    "/payment-cancel",
    "/signup-splash",
    "/signup",
    "/login",
];
